import React, { useState, useEffect, useCallback } from "react";
// import { ScalingContainer } from "../../../AppStyled";

import { ReactComponent as CloseSVG } from "../../../assets/notifyClose.svg";
import {
  NotificationFrame,
  Scaling,
  NotificationContainer,
  Icon,
} from "./NotificationStyled";
import useSound from "use-sound";
import notify from "../../../audio/notify.mp3";

export default function Notification({
  notifyText,
  handleNotification,
  fadeOut,
  userSettings: { sound, volume },
}) {
  const [notifySfx] = useSound(notify, { volume });
  useEffect(() => {
    if (sound) notifySfx();
  }, [sound, notifySfx]);
  const [intViewportHeight, setintViewportHeight] = useState(667);

  const handleResize = useCallback((a) => {
    if (window.innerHeight < 667) {
      setintViewportHeight(window.innerHeight);
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
  }, [handleResize]);
  return (
    <NotificationFrame>
      <Scaling className="Scaling" h={intViewportHeight}>
        <NotificationContainer fadeOut={fadeOut}>
          <Icon />
          <p>{notifyText}</p>
          <CloseSVG onClick={() => handleNotification(false)} />
        </NotificationContainer>
      </Scaling>
    </NotificationFrame>
  );
}
